export default "__VITE_ASSET__CJ60AwVE__"